<div class="wrapper">
  <div class="header">
    <span
      class="backBtn clickable"
      (click)="onBack()"
      i18n="@@general.doucments"
      ><img src="assets/Keen&Wise_back.png" />
      Documents
    </span>
  </div>
  <div class="body">
    <app-document-viewer [pdf]="pdf"></app-document-viewer>
    <div class="buttons">
      <button
        class="button accept"
        (click)="onValidate()"
        i18n="@@general.validate"
      >
        Validate
      </button>
      <button
        class="button reject"
        (click)="onReject()"
        i18n="@@general.reject"
      >
        Reject
      </button>
    </div>
  </div>
</div>
